module.exports = __webpack_public_path__ + "img/home-service-nongye.f38b1464.png";